export function getSpotFromSearch(search: string, key: string) {
  const params = new URLSearchParams(search);
  const rawSpot = params.get(key);

  if (!rawSpot) {
    return;
  }

  const maybeSpot = parseInt(rawSpot);

  if (Number.isNaN(maybeSpot)) {
    return;
  }

  if (maybeSpot < 1 || maybeSpot > 20) {
    return;
  }

  return maybeSpot;
}
